import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/fonts/pretendard/pretendard.css";
import "./assets/fonts/satoshi/satoshi.css";
import "./assets/fonts/aptos/aptos.css";
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
